import footer from "../../../assets/img/projects/Genome/Genome-footer.png";
import card1 from "../../../assets/img/projects/Genome/Genome-card1.png";
import card2 from "../../../assets/img/projects/Genome/Genome-card2.png";
import card3 from "../../../assets/img/projects/Genome/Genome-card3.png";
import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function Card() {
  const containerRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: containerRef.current,
          start: "top 80%",
          end: "bottom top",
          toggleActions: "play none none reverse",
          markers: false,
        },
      });

      const divs = containerRef.current.querySelectorAll(".Genome-card > div");

      tl.fromTo(
        divs,
        { opacity: 0, y: 100, filter: "blur(2px)" },
        {
          opacity: 1,
          y: 0,
          filter: "blur(0px)",
          duration: 1,
          ease: "power2.out",
          stagger: 0.2,
        }
      );
    }, containerRef);

    return () => ctx.revert();
  }, []);

  return (
    <>
      <div className="Genome-card" ref={containerRef}>
        <div>
          <img src={card1} alt="" />
        </div>
        <div>
          <img src={card2} alt="" />
        </div>
        <div>
          <img src={card3} alt="" />
        </div>
      </div>
      <img className="img-footer" src={footer} alt="" />
    </>
  );
}
